import '../paedml-modal.tag'
import '../paedml-form-input.tag'
import '../components/paedml-time-picker.tag'

<paedml-modal-edit-accesslist>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} edit={opts.edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol}
       idtextcol={opts.idtextcol} submitfunc={submitHandler} ref='modal'>

    <yield to="fields">

      <div if={parent.loading} class="d-flex justify-content-center pt-5 pb-5">
        <p class="my-auto">Firewall-Einstellungen werden aktualisiert...</p>
        <div class="sk-wave">
          <div class="sk-rect sk-rect1"></div>
          <div class="sk-rect sk-rect2"></div>
          <div class="sk-rect sk-rect3"></div>
          <div class="sk-rect sk-rect4"></div>
          <div class="sk-rect sk-rect5"></div>
        </div>
      </div>

      <div class="paedml-input-group" if={!parent.loading}>
        <div class="pb-1" if={parent.variant === 'klasse'}>
            Meine temporäre Whitelist-Einstellungen wählen:
        </div>
        <div class="row" if={parent.variant === 'klasse'}>
          <div class="col-sm-12">
            <paedml-form-input placeholder="Whitelist-Vorlage wählen" label="Whitelist-Vorlage"
                type="select" values={parent.getWhitelistTemplates()}
                handlechange={parent.handleWhitelistTemplateChange}
                required data-msg="Bitte wählen Sie die Whitelist-Vorlage aus"
                name="whitelistTemplate" ref="whitelistTemplate"
            />
          </div>
        </div>
        <div class="pb-1" if={parent.variant === 'template'}>
            Meine temporäre Whitelist-Einstellungen für Klasse wählen:
        </div>
        <div class="row" if={parent.variant === 'template'}>
          <div class="col-sm-12">
            <paedml-form-input placeholder="Klasse wählen" label="Klasse"
                type="select" values={parent.getClassesMapped()}
                handlechange={parent.handleSchoolClassChange}
                required data-msg="Bitte wählen Sie die Klasse aus"
                name="schoolClass" ref="schoolClass"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <label>Whitelist</label>
            <textarea class="form-control" name="whitelist" cols="28" rows="10" readonly>
            </textarea>
          </div>
          <div class="col-sm-6 paedml-margin">
            <div class="row">
              <div class="col-sm-12">
                <paedml-time-picker name="expiration" label="Whitelist gilt heute bis Uhrzeit:"
                  allowpasttimes={false}
                  required data-msg="Bitte wählen Sie die Ablaufuhrzeit der Whitelist aus"
                />
              </div>
              <div class="col-sm-12">
                <paedml-form-input name="whitelistOnly" placeholder="Nur Whitelist verwenden" fgclass="py-1"
                  type="checkbox" revlut="jaNein"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="paedml-input-group" if={!parent.loading}>
        <div class="pb-1">
          Aktuelle wirkende Whitelist-Einstellungen für Klasse:
        </div>
        <div class="row">
          <div class="col-sm-6">
            <label>Whitelist</label>
            <textarea class="form-control" name="currentWhitelist"
                cols="28" rows="10" readonly>
            </textarea>
          </div>
          <div class="col-sm-6 paedml-margin">
            <div class="row">
              <div class="col-sm-12">
                <paedml-form-input name="currentWhitelistActive" placeholder="Whitelist aktiv" fgclass="py-1"
                    type="checkbox" revlut="jaNein" readonly
                />
              </div>
              <div class="col-sm-12">
                <paedml-form-input name="currentWhitelistOnly" placeholder="Nur Whitelist verwenden" fgclass="py-1"
                    type="checkbox" revlut="jaNein" readonly
                />
              </div>
              <div class="col-sm-12">
                <paedml-form-input name="activatedByUser" label="Aktiviert von Benutzer"
                    readonly
                />
              </div>
              <div class="col-sm-12">
                <paedml-form-input name="expirationDP" label="Läuft ab heute, Uhrzeit"
                    readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </yield>
  </paedml-modal>

  <script>
    import store from '../../store'
    import * as mapper from '../../mapper'
    import * as R from 'ramda'
    import Session from '../../store/session'
    import API from '../../api'
    import moment from 'moment'

    this.opname = this.opts.opname
    this.edit = this.opts.edit ? true : false
    this.data = {}
    this.session = Session
    this.variant = this.opts.variant || 'klasse'

    this.loadCurrentWhitelist = (id) => {
      this.loading = true
      this.data.schoolClassId = id
      
      return API.fwklassen.whitelist(id).then(rsp => {

        const [fw, status] = rsp

        this.data.currentWhitelist = R.join('\n', fw.whitelist)
        this.data.currentWhitelistActive = fw.whitelistActive
        this.data.currentWhitelistOnly = fw.whitelistOnly
        this.data.activatedByUser = fw.activatedByUser ? fw.activatedByUser : 'Administrator'
        this.data.expirationDP = fw.expiration ? moment(fw.expiration).format("HH:mm") : 'nie'

        this.loading = false

        return rsp
      })
    }

    this.getWhitelistTemplates = () => this.data.whitelistTemplates || []

    this.getClassesMapped = () => {
      const klassen = []

      R.forEachObjIndexed((klasse, schulartId) => {
        if (schulartId !== 'undefined' && schulartId !== 'all') {
          const schulart = this.session.map.schularten[schulartId]
          klasse.forEach(v => {
            const klasse = `${schulart}_${v[1]}`
            klassen.push([v[0], klasse])
          })
        }
      })(Session.lut.klassenBySchulart)
      return klassen
    }

    this.refreshWhitelistTemplates = () => {
      this.loading = true
      return API.fwktemplates.get().then(rsp => {
        const [templates, status] = rsp

        this.data.templates = templates.reduce((acc, v) => { acc[v.id] = v; return acc}, {})

        this.data.whitelistTemplates = templates.map(e => [e.id, e.name])
        this.data.whitelistTemplate = ''

        this.loading = false
        this.refs.modal.trigger('refreshData')
      })
    }

    this.handleSchoolClassChange = (val) => {
      if (val === ' ' || val == null) {
        this.data.currentWhitelist = ''
        return
      }
      this.data.schoolClassId = val
      API.fwklassen.whitelist(val).then(rsp => {

        const [fw, status] = rsp

        this.data.currentWhitelist = R.join('\n', fw.whitelist)
        this.data.currentWhitelistActive = fw.whitelistActive
        this.data.currentWhitelistOnly = fw.whitelistOnly
        this.data.activatedByUser = fw.activatedByUser ? fw.activatedByUser : 'Administrator'
        this.data.expirationDP = fw.expiration ? moment(fw.expiration).format("HH:mm") : 'nie'

        this.refs.modal.trigger('refreshData')
      })
    }

    this.handleWhitelistTemplateChange = (val) => {
      if (val === ' ' || val == null) {
        this.data.whitelist = ''
        return
      }
      const fw = this.data.templates[val]
      this.data.whitelist = R.join('\n', fw.whitelist)
      this.data.whitelistTemplateId = val
    }

    this.on('rowMappingRequested', (cols) => {

      if( this.variant === 'klasse') {
        this.loadCurrentWhitelist(cols[0]).then(rsp => {
          this.refreshWhitelistTemplates().then(() => {

           this.refs.modal.trigger('refreshData')
          })
        })
      }

      if(this.variant === 'template') {
        this.data.whitelist = R.join('\n', cols[4])
        this.data.whitelistTemplateId = cols[0]
        this.data.schoolClass = ''
      }

      this.data.whitelistActive = true
    })

    this.submitHandler = formData => {
      const payload = {
        schoolClassId: this.data.schoolClassId,
        expiration: formData.expiration,
        whitelistOnly: formData.whitelistOnly,
        whitelistTemplateId: this.data.whitelistTemplateId
      }
      return API.fwklassen.updateWhitelist(this.data.schoolClassId, payload).then(rsp => {
        const [result, status] = rsp
        if(status.success) {
          this.parent.trigger('reloadTable')
          return 'Änderungen erfolgeich übernommen.'
        }
        else {
          if(data.message){
            return Promise.reject(data.message)
          }
          return Promise.reject('Änderungen konnten nicht übernommen werden.')
        }
      })
    }

  </script>
</paedml-modal-edit-accesslist>
